import _ from 'lodash';
import utils from 'lib/utils';
import config from 'config';
import { reqTransform, resTransform } from './transforms';

const { baseUrl } = config;

export const create = async (params = {}) => {
  try {
    let qs = reqTransform.create(params);
    const url = `${baseUrl}/BioFuelRequirementOffers/api/Deal/CaptureWalkInDeal?${qs}`;
    const res = await utils.fetch(url, {
      method: 'POST',
    }).ready;
    const resData = await utils.processApiRes(res);
    return resTransform.create(resData);
  } catch (err) {
    console.log('CaptureWalkInDeal-create->err---->', err);
    const errors = await utils.processApiErrors(err, '', 'CaptureWalkInDeal');
    throw errors;
  }
};
